import { render } from "./Workspace.vue?vue&type=template&id=35b920d8&scoped=true&ts=true"
import script from "./Workspace.vue?vue&type=script&lang=ts"
export * from "./Workspace.vue?vue&type=script&lang=ts"

import "./Workspace.vue?vue&type=style&index=0&id=35b920d8&lang=css&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35b920d8"]])

export default __exports__